import { useTranslation } from 'react-i18next';

export const useCommonTranslation = (): Function => {
  const { t } = useTranslation('common');
  return (
    key: string | TemplateStringsArray | (string | TemplateStringsArray)[],
    params?: any,
  ) => t(key, params) || '';
};
